import { BASE_PATH } from '../../shared/types';
import { NativeLink } from './NativeLink';

/** Shown on every page. privacy.html and terms-of-service.html repeat this markup as static HTML. */
export function SiteFooter() {
  return (
    <footer class="site-footer">
      <p>Free to use.<br />
        Made by <NativeLink href="https://brushycreeksoftware.com/">Brushy Creek Software</NativeLink>.<br />
        Not an official product of <NativeLink href="https://www.churchofjesuschrist.org/">The Church of Jesus Christ of <span class="nowrap">Latter-day Saints</span></NativeLink>.
      </p>
      <nav aria-label="Site">
        <a href={`${BASE_PATH}/help`}>Help</a>
        {/* `native` makes the router let the browser load these static pages. */}
        <NativeLink href={`${BASE_PATH}/privacy`}>Privacy Policy</NativeLink>
        <NativeLink href={`${BASE_PATH}/terms-of-service`}>Terms of Service</NativeLink>
      </nav>
    </footer>
  );
}
